import React from 'react';
import Proptypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const NavTitle = ({ type, style, content }) => {
    const { title, url, logo } = content;
    const getWrapClass = () => {
        let typeClass = '';

        if (type === 'small') {
            typeClass = styles.wrapSmall;
        } else if (type === 'large') {
            if (logo) {
                typeClass = `${styles.wrapLarge} ${styles.wrapLargeAd}`;
            } else {
                typeClass = styles.wrapLarge;
            }
        }

        return `${styles.wrap} ${typeClass}`;
    };

    return (
        <div className={getWrapClass()} style={style}>
            <div className={styles.wrapLeft}>{title}</div>
            <div className={styles.wrapRight}>
                {logo ? (
                    <div className={styles.logo}>
                        {url ? (
                            <a href={url} target="_blank">
                                <img src={logo} alt="" />
                            </a>
                        ) : (
                            <img src={logo} alt="" />
                        )}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

NavTitle.propTypes = {
    type: Proptypes.string,
    style: Proptypes.object,
    content: Proptypes.object,
};

export default errorBoundary(NavTitle);
